import { mobileMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled from 'styled-components';

export const Container = styled.section`
  margin: 15px 0 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (${tabletMax}) {
    flex-direction: column;
  }
`;

export const LinksContainer = styled.div`
  display: flex;
  margin-left: 15px;

  @media (${tabletMax}) {
    margin-left: 0;
    margin-top: 15px;
  }
`;

export const Anchor = styled(Link)`
  cursor: pointer;
  padding: 0 15px;
  border-left: 1px solid ${(props) => props.theme.backgroundLight};

  &:hover p {
    color: ${(props) => props.theme.backgroundLight};
  }

  @media (${tabletMax}) {
    &:first-child {
      border-left: none;
    }
  }

  @media (${mobileMax}) {
    padding: 0 10px;
  }
`;
